/**
 * Glossary stats summary footer — extracted from AdminGlossaryTab.
 * Renders category badges (clickable to filter) and per-context coverage.
 */
import React from 'react';
import { Badge } from '@/components/ui/badge';

const GlossaryStatsSummary = ({ stats, onCategoryClick }) => {
  if (!stats) return null;

  const categoryEntries = stats.by_category
    ? Object.entries(stats.by_category).slice(0, 8)
    : [];
  const contextEntries = stats.by_context
    ? Object.entries(stats.by_context)
    : [];

  return (
    <div className="mt-4 p-4 bg-slate-50 dark:bg-slate-800/50 rounded-lg">
      <div className="flex flex-wrap gap-4">
        {categoryEntries.length > 0 && (
          <div>
            <span className="text-sm font-medium text-slate-600 dark:text-slate-400">
              Kategorien:
            </span>
            <div className="flex flex-wrap gap-1 mt-1">
              {categoryEntries.map(([cat, count]) => (
                <Badge
                  key={cat}
                  variant="secondary"
                  className="cursor-pointer hover:bg-slate-200"
                  onClick={() => onCategoryClick && onCategoryClick(cat)}
                  data-testid={`stats-category-${cat}`}
                >
                  {cat}: {count}
                </Badge>
              ))}
            </div>
          </div>
        )}
        {contextEntries.length > 0 && (
          <div>
            <span className="text-sm font-medium text-slate-600 dark:text-slate-400">
              Kontext-Abdeckung:
            </span>
            <div className="flex flex-wrap gap-1 mt-1">
              {contextEntries.map(([ctx, count]) => (
                <Badge key={ctx} variant="outline">{ctx}: {count}</Badge>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GlossaryStatsSummary;
